import React, { useMemo } from 'react';

import { Grid, Paper, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

function getMemoContent(data, memoText) {
  return memoText || data?.memoText || data?.memo || '';
}

function MemoPanel({ content }) {
  if (!content) return null;

  return (
    <Grid item xs={12}>
      <Typography variant="subtitle1">Execução</Typography>
      <Paper
        variant="outlined"
        style={{
          marginTop: 8,
          padding: 12,
          maxHeight: 220,
          overflowY: 'auto',
        }}
      >
        <div
          style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Paper>
    </Grid>
  );
}

export default function View({ data, memoText }) {
  const memoContent = useMemo(() => getMemoContent(data, memoText), [data, memoText]);

  return (
    <Grid
      container
      spacing={2}
      style={{
        width: '100%',
        margin: 0,
        padding: 8,
      }}
    >
      <MemoPanel content={memoContent} />
    </Grid>
  );
}

MemoPanel.propTypes = {
  content: PropTypes.string,
};

MemoPanel.defaultProps = {
  content: '',
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  memoText: PropTypes.string,
};

View.defaultProps = {
  data: {},
  memoText: '',
};
